import { createApp, defineAsyncComponent, ref, onMounted, inject } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import { createI18n } from 'vue-i18n';
import Recaptcha from './plugins/recaptcha/';
import CookiesBar from './plugins/cookies-bar/index.js';
import Modals from './plugins/modals/index.js';
import Collapse from './plugins/collapse/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';
import Animations from './plugins/animations/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
const BgImage = defineAsyncComponent(() => import('./components/bg-image/index.vue'));
const BgVideo = defineAsyncComponent(() => import('./components/bg-video/index.vue'));
const MarqueeText = defineAsyncComponent(() => import('vue-marquee-text-component'));
const PropertiesList = defineAsyncComponent(() => import('./properties-list.vue'));
const RequestAccessForm = defineAsyncComponent(() => import('./request-access-form.vue'));
// const ContactForm = defineAsyncComponent(() => import('./contact-form.vue'));
const GoogleMap = defineAsyncComponent(() => import('./components/google-map/index.vue'));

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import { Fancybox } from '@fancyapps/ui';
import galleryOptions from "./imports/fancyOptions.js";
Fancybox.bind("[data-fancybox]", galleryOptions);
import { viewportSize, devices } from './imports/utils';

const i18n = createI18n({
    legacy: false,
    locale: window.Laravel.locale,
    messages: window.Laravel.translations,
});

createApp({
    components: {
        BgImage,
        BgVideo,
        MarqueeText,
        PropertiesList,
        RequestAccessForm,
        // ContactForm,
        GoogleMap
    },
    setup() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        

        const openFancybox = (gallery, title = null) => {
            Fancybox.show(
                gallery,
                {
                    ...galleryOptions,
                    on: {
                        initCarousel: (fancybox) => {
                            const carouselEl = fancybox.getContainer().querySelector('.fancybox__carousel');

                            if (title) {
                                const titleEl = document.createElement('div');
                                titleEl.classList.add('fancybox__title');
                                if (title) titleEl.textContent = title;

                                carouselEl.prepend(titleEl);

                                setTimeout(() => {
                                    carouselEl.prepend(titleEl);
                                }, 0);
                            }
                        },
                    },
                }
            );

            // Fancybox.fromSelector(`[data-fancybox="${selector}"]`)
        }

        ///////////////////////////////////////////////////////////////////////////// scrollTop
        const scrollTop = ref(0);
        const onScroll = () => {
            scrollTop.value = window.scrollY;
        }
        window.addEventListener("scroll", onScroll, { passive: true });

        ///////////////////////////////////////////////////////////////////////////// viewportSize
        const viewport = ref(viewportSize());
        const onResize = () => {
            viewport.value = viewportSize();
        }
        window.addEventListener("resize", onResize, { passive: true });

        onMounted(() => {
            if (devices()) {
                document.getElementsByTagName('html')[0].classList.add('touch-device');
            }
        });

        const mounted = ref(false);
        onMounted(() => {
            mounted.value = true;
        });

        ///////////////////////////////////////////////////////////////////////////// Animations
        const $animations = inject('$animations');

        onMounted(() => {
            setTimeout(() => {
                $animations.blocks.init();
                $animations.parallax.init();
                $animations.menu.init('.main-menu>li', ['.menu-wrapper .terms-menu', '.menu-wrapper .logo-link', '.langs-wrapper']);
                // $animations.counter.init();
            }, 0);
        });

        return {
            assets: `/site/${process.env.MIX_TEMPLATE_FOLDER}/dist`,
            openFancybox,
            scrollTop,
            viewport,
            mounted,
        }
    },
})
    .use(i18n)
    .use(Recaptcha, {
        key: process.env.MIX_RECAPTCHA,
        hide: true
    })
    .use(CookiesBar)
    .use(Modals)
    .use(Collapse)
    .use(Animations)
    .use(SiteDrawer)
    .mount('#app')